"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsx)("svg", {
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 401.8 400.8",
    width: "100%",
    height: "100%",
    children: (0, jsx_runtime_1.jsxs)("g", {
      children: [(0, jsx_runtime_1.jsx)("path", {
        fill: "currentColor",
        d: "M200.9,24.8c-97,0-175.7,78.7-175.7,175.7s78.7,175.6,175.7,175.6s175.7-78.7,175.7-175.7\n\t\tS297.9,24.8,200.9,24.8z M200.9,351.7c-83.5,0-151.2-67.7-151.2-151.2S117.4,49.3,200.9,49.3S352.1,117,352.1,200.5\n\t\tC352.1,284,284.4,351.7,200.9,351.7z"
      }), (0, jsx_runtime_1.jsx)("path", {
        fill: "currentColor",
        d: "M249.1,113.2c-20.4,0-38.4,11.9-48.2,29.6c-9.8-17.7-27.8-29.6-48.2-29.6c-30.9,0-56,27.1-56.2,60.4\n\t\tc-0.4,6.7-2.9,86.2,101,134.3l3.4,1.6l3.4-1.6c103.9-48.2,101.4-127.6,101-134.3C305.1,140.3,280,113.2,249.1,113.2z"
      })]
    })
  });
};

exports.default = Icon;